import React, { ReactNode } from "react";
import { Card as MuiCard } from "@mui/material";
import "./card.scss";

interface CardContainerProps {
  children: ReactNode;
  className?: string;
  [key: string]: any;
}

export const Card: React.FC<CardContainerProps> = ({
  children,
  className,
  ...rest
}: CardContainerProps) => {
  return (
    <MuiCard
      tabIndex={0}
      elevation={0}
      className={`card ${className}`}
      {...rest}
    >
      {children}
    </MuiCard>
  );
};
